import React from "react";

type ProgressBarProps = {
  progress: number; // 0-100
};

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  // Ensure progress is between 0 and 100
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <div className="flex gap-3 items-center w-full">
      <div className="flex-1 shrink self-stretch my-auto w-full rounded-lg basis-0">
        <div className="flex flex-col items-start bg-gray-200 rounded-full">
          <div
            className="flex shrink-0 h-2 bg-blue-600 rounded-full"
            style={{ width: `${clampedProgress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
